<div class="form-metrics-chart-legend" *ngIf="items?.length">
  <span
    class="legend-item"
    *ngFor="let item of items"
    [attr.title]="item.display.ariaLabel"
    [attr.aria-label]="item.display.ariaLabel">
    <span class="legend-marker" [style.background-color]="item.color"></span>
    <i
      *ngIf="item.display.mode === 'icon'"
      class="feather icon-{{ item.display.iconName }} legend-icon"
      aria-hidden="true"></i>
    <span *ngIf="item.display.mode === 'text'" class="legend-label">{{ item.display.text }}</span>
  </span>
</div>
